import { render, staticRenderFns } from "./BackstagePass.vue?vue&type=template&id=46f6a6dc&scoped=true&"
import script from "./BackstagePass.vue?vue&type=script&lang=js&"
export * from "./BackstagePass.vue?vue&type=script&lang=js&"
import style0 from "./BackstagePass.vue?vue&type=style&index=0&id=46f6a6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6a6dc",
  null
  
)

export default component.exports